import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import PerformanceCycleInstancesCreateForm from './PerformanceCycleInstancesCreateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function PerformanceCycleInstancesCreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Example Template | Agregar instancia de ciclo de performance"
    >
      <Container maxWidth={false}>
        <Header />
        <PerformanceCycleInstancesCreateForm />
      </Container>
    </Page>
  );
}

export default PerformanceCycleInstancesCreateView;
